import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('deploymentHistory');
const type = createActionType('deploymentHistory');

export const OPEN_DEPLOYMENT_HISTORY_DIALOG = type('OpenDeploymentHistoryDialog');
export const CLOSE_DEPLOYMENT_HISTORY_DIALOG = type('CloseDeploymentHistoryDialog');

export const LOAD_DEPLOYMENT_HISTORY = apiType('LoadDeploymentHistory');

export const OPEN_RESTORE_TRANSFORMATION_DEPLOYMENT_DIALOG = type(
    'OpenRestoreTransformationDeploymentDialog'
);
export const CLOSE_RESTORE_TRANSFORMATION_DEPLOYMENT_DIALOG = type(
    'CloseRestoreTransformationDeploymentDialog'
);
export const RESTORE_TRANSFORMATION_DEPLOYMENT = apiType('RestoreDeployment');
